import React from "react";
import { Navigate } from "react-router-dom";
import { hasPerm } from "../utils/permission";

const ProtectedRoute = ({ children,slug }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  // permission check
  if (slug && !hasPerm(slug)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
